// extracted by mini-css-extract-plugin
export default {"inputs":"TerminarTrabajoCajas_inputs__9V311","input":"TerminarTrabajoCajas_input__UgdGQ"};